import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { PaginationType } from '../types/Pagination.types';
import type { ProviderDto, ProviderListParams } from './providers.schema';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { PUBLIC_QUERY_STALE_TIME } from '../queryOptions.helpers';
import { providersApi } from './providers.api';

export const providerQueryOptions = {
  /***
  * Fetch providers list
  */
  list: (params?: ProviderListParams, options?: QueryOptionsOverride<PaginationType<ProviderDto>>) => queryOptions({
    queryKey: [QueriesKeys.providers, params],
    queryFn: () => providersApi.getAll(params),
    ...options,
  }),
  /***
  * Fetch provider by Id or alias
  */
  byIdOrAlias: (idOrAlias: string) => queryOptions({
    queryKey: [QueriesKeys.provider, idOrAlias],
    queryFn: () => providersApi.getByIdOrAlias(idOrAlias),
    staleTime: PUBLIC_QUERY_STALE_TIME,
  }),
};
